import { render, staticRenderFns } from "./DataVersionInfo.vue?vue&type=template&id=3bb15491&scoped=true"
import script from "./DataVersionInfo.vue?vue&type=script&lang=js"
export * from "./DataVersionInfo.vue?vue&type=script&lang=js"
import style0 from "./DataVersionInfo.vue?vue&type=style&index=0&id=3bb15491&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb15491",
  null
  
)

export default component.exports